// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { Query } from 'react-apollo'
import moment from 'moment'
import { i18n } from '../../index'
import { Button } from '@mui/material'
import ThumbableServiceTable from './ThumbableServiceTable'
import ThumbableServiceDialog from './ThumbableServiceDialog'
import type { ThumbableService } from './thumbableServiceTypes'
import css from './thumbableServicePage.css'
import withUser from '../../auth/withUser'
import { fetchStationThumbsUpTarget } from './thumbableServiceQueries'
import Loader from '../../../common/loader/Loader'
import { ThumbsUpTargetsEditor } from './ThumbsUpTargetsEditor'
import { YearTargetsSection } from '../monthlyTargets/YearTargetsSection'
import ActivityWeightsTable from '../activityWeights/ActivityWeightsTable'
import { fetchActivityWeights } from '../activityWeights/queries'
type ThumbableServicePageProps = {
  data: Array<ThumbableService>
  stationId?: string
}
type ThumbableServicePageState = {
  isDialogOpen: boolean
  data: ThumbableService | null | undefined
}

@withUser
class ThumbableServicePage extends React.PureComponent<ThumbableServicePageProps, ThumbableServicePageState> {
  state = {
    isDialogOpen: false,
    data: null,
  }
  openDialog = () => {
    this.setState({
      isDialogOpen: true,
    })
  }
  closeDialog = () => {
    this.setState({
      isDialogOpen: false,
      data: null,
    })
  }
  onEdit = (data: ThumbableService) => {
    this.setState({
      data,
    })
    this.openDialog()
  }

  render() {
    const { data: thumbableServices, stationId, user } = this.props
    const { isDialogOpen, data } = this.state
    const currentDate = moment()
    const nextYearDate = currentDate.clone().add(1, 'year')
    const lastYear = currentDate.clone().subtract(1, 'year').year()
    const currentYear = currentDate.year()
    return (
      <div className={css.component}>
        {stationId && (
          <Query
            query={fetchStationThumbsUpTarget}
            variables={{
              stationId,
              date: currentDate.toDate(),
              nextYearDate: nextYearDate.toDate(),
              lastYear,
              currentYear,
            }}
          >
            {({ loading, error, data }) => (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <YearTargetsSection
                  currentYear={
                    <ThumbsUpTargetsEditor
                      user={user}
                      stationId={stationId}
                      date={currentDate.toDate()}
                      thumbsUpTargetData={data.thumbsUpTarget}
                      lastYearOutcomeData={data.thumbsUpLastYear}
                    />
                  }
                  nextYear={
                    <ThumbsUpTargetsEditor
                      user={user}
                      stationId={stationId}
                      date={nextYearDate.toDate()}
                      thumbsUpTargetData={data.thumbsUpTargetNextYear}
                      lastYearOutcomeData={data.thumbsUpCurrentYear}
                    />
                  }
                />
              </Loader>
            )}
          </Query>
        )}
        <ThumbableServiceTable data={thumbableServices} stationId={stationId} onEdit={this.onEdit} />
        <div className={css.bottom}>
          <Button onClick={this.openDialog} variant='contained' color='primary'>
            {i18n.t('buttons.create')}
          </Button>
        </div>
        {stationId && (
          <Query
            query={fetchActivityWeights}
            variables={{
              stationId,
              type: 'thumbs_up',
            }}
          >
            {({ loading, error, data }) => (
              <Loader
                {...{
                  loading,
                  error,
                }}
              >
                <ActivityWeightsTable stationId={stationId} data={data.activityWeights} type='thumbs_up' />
              </Loader>
            )}
          </Query>
        )}
        <ThumbableServiceDialog data={data} stationId={stationId} isOpen={isDialogOpen} onClose={this.closeDialog} />
      </div>
    )
  }
}

export default ThumbableServicePage
